import React from 'react';
import colors from '../../../config/colors';

// The one "nothing here yet" look across the dashboard (the same as the Timeline's): an icon in a soft purple disc, a title and
// an optional hint. `icon` is a Font Awesome class ('far fa-images') or an element. `compact` is the smaller version for a
// table, a dialog or a card; `bare` drops the white card around it (inside something that already is one).
const EmptyState = ({ icon = 'far fa-folder-open', title, subtitle, hint, compact = false, bare = false, style }) => {
  const text = subtitle || hint;
  const disc = compact ? 52 : 84;
  return (
    <div
      style={{
        textAlign: 'center',
        padding: compact ? '22px 16px' : '48px 24px',
        ...(!bare && {
          background: '#fff',
          border: '1px solid #ece6f2',
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        }),
        ...style,
      }}>
      <div
        style={{
          width: disc,
          height: disc,
          margin: `0 auto ${compact ? 10 : 16}px`,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #F5EDFB, #EDE1F7)',
          color: colors.accent,
          fontSize: compact ? 22 : 34,
        }}>
        {typeof icon === 'string' ? <i className={icon} aria-hidden="true" /> : icon}
      </div>
      <div style={{ fontSize: compact ? 14 : 18, fontWeight: 'bold', color: colors.accentDark }}>{title}</div>
      {!!text && (
        <div
          style={{
            fontSize: compact ? 12.5 : 14,
            color: colors.grey3,
            maxWidth: 420,
            margin: '6px auto 0',
          }}>
          {text}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
